import React from 'react';

function ShareSVG() {
  return (
    <svg
      id="share_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Path_1275"
        data-name="Path 1275"
        d="M0,0H24V24H0Z"
        fill="none"
      />
      <path
        id="Path_1276"
        data-name="Path 1276"
        d="M14.378,12.68a2.209,2.209,0,0,0-1.487.584L7.483,10.116a2.483,2.483,0,0,0,.068-.531,2.483,2.483,0,0,0-.068-.531L12.83,5.937A2.27,2.27,0,1,0,12.1,4.276a2.483,2.483,0,0,0,.068.531L6.823,7.924a2.276,2.276,0,1,0,0,3.322l5.4,3.155a2.14,2.14,0,0,0-.061.493,2.215,2.215,0,1,0,2.215-2.215Z"
        transform="translate(2.173 2.405)"
        fill="#0279ff"
      />
    </svg>
  );
}

export default ShareSVG;
